import type { CSSProperties, MouseEvent } from 'react';
import type { IProductListItem } from '@/api/types/product';

export const PROMOTION_FLASH_SALE_PC_SLIDES_PER_VIEW = 3.68;
export const PROMOTION_FLASH_SALE_PC_SPACE_BETWEEN = 12;
export const PROMOTION_FLASH_SALE_PC_MIN_SLIDE_WIDTH = 313;

interface CreateFlashSaleProductCardClickHandlerParams {
  item: IProductListItem;
  index: number;
  onProductClick: (item: IProductListItem, index: number) => void;
}

export function getPcFlashSaleSwiperSlideStyle(): CSSProperties {
  const totalGap =
    PROMOTION_FLASH_SALE_PC_SPACE_BETWEEN * (PROMOTION_FLASH_SALE_PC_SLIDES_PER_VIEW - 1);

  return {
    marginRight: `${PROMOTION_FLASH_SALE_PC_SPACE_BETWEEN}px`,
    width: `max(${PROMOTION_FLASH_SALE_PC_MIN_SLIDE_WIDTH}px, calc((100% - ${totalGap.toFixed(2)}px) / ${PROMOTION_FLASH_SALE_PC_SLIDES_PER_VIEW}))`,
  };
}

export function createFlashSaleProductCardClickHandler({
  item,
  index,
  onProductClick,
}: CreateFlashSaleProductCardClickHandlerParams) {
  return (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onProductClick(item, index);
  };
}
